import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { blue, neutral } from '../../theme/colors';

const StyledCheckbox = withStyles({
  root: {
    height: 16,
    width: 16,
    borderRadius: 3,
    border: `1px solid ${neutral[300]}`,
    color: 'transparent',
    padding: 0,
    '&:hover': {
      border: `1px solid ${blue[300]}`
    },
    '&$checked': {
      color: blue[600]
    },
    '&$disabled': {
      color: neutral[500]
    }
  },
  checked: {},
  disabled: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

export default StyledCheckbox;
